import { useContextSafe } from 'helpers/utils';
import { createContext } from 'react';
import { action, computed, observable, makeObservable } from 'mobx';

function getTimestamp() {
  return Math.floor(Date.now() / 1000);
}

class ToastStore implements IToastStore {
  MAX_AGE = 30; // seconds

  @observable intetnalToasts: IStoredToast[] = [];

  constructor() {
    makeObservable(this);
  }

  @action.bound addToast(toast: IToast) {
    this.intetnalToasts.push({
      id: JSON.stringify({ type: toast.type, title: toast.title, description: toast.description }),
      timestamp: getTimestamp(),
      ...toast,
    });
    this.removeOutdatedToasts();
  }

  @action.bound removeToast(id: string) {
    this.intetnalToasts = this.intetnalToasts.filter((storeItem) => storeItem.id !== id);
    this.removeOutdatedToasts();
  }

  @action.bound removeOutdatedToasts() {
    const now = getTimestamp();
    this.intetnalToasts.filter((item) => item.timestamp + this.MAX_AGE > now);
  }

  @computed get toasts() {
    const now = getTimestamp();

    return Object.values(
      this.intetnalToasts
        .filter((item) => item.timestamp + this.MAX_AGE > now)
        .reduce((acc, cur) => {
          if (cur.id in acc) {
            acc[cur.id].count += 1;
          } else {
            acc[cur.id] = { count: 1, toast: cur };
          }
          return acc;
        }, {} as Record<string, IReducedToast>),
    ) as IReducedToast[];
  }
}

const ToastStoreContext = createContext<ToastStore | null>(null);
const useToastStore = () => useContextSafe(ToastStoreContext);

export { ToastStoreContext, useToastStore };
export default ToastStore;
